import { createWithEqualityFn } from 'zustand/traditional';
import { persistForUser } from '@erikdakoda/ui/shared/persistForUser';

interface State {
  editedFeedbackId: string | null;
  currentFeedbackId: string | null;
}

interface Action {
  setEditedFeedbackId: (feedbackId: State['editedFeedbackId']) => void;
  setCurrentFeedbackId: (feedbackId: State['currentFeedbackId']) => void;
}

export const useFeedbackStore = createWithEqualityFn<State & Action>()(
  persistForUser(
    (set) => ({
      editedFeedbackId: null,
      currentFeedbackId: null,

      setEditedFeedbackId: (editedFeedbackId) => set(() => ({ editedFeedbackId })),
      setCurrentFeedbackId: (currentFeedbackId) => set(() => ({ currentFeedbackId })),
    }),
    {
      name: 'feedback-store',
    },
  ),
);
